<template>

  <b-row>
    <b-col md="12">
      <b-card
        no-body
        :class="{ open: visibleBody }"
      >
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="visibleBody = !visibleBody"
          style="padding: 1rem; background-color: #0080C9; color: white; font:45px; padding:15px;"
        >
          <span class="lead collapse-title">
            <strong>IMÁGENES</strong>
          </span>
          <i :class=" visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>

        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="">

            <RegistrarEnvioImagenes
              :saveInState = "saveImagenesInState"
              :esIess="esCoberturaIess"
              :tokenAtencion="tokenAtencion"
              :respaldo="dataRespaldo"
            />

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>

  
</template>

<script>
import { mapState } from 'vuex';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { RegistrarEnvioImagenes } from '@/views/imagen/components';
import { loadRespaldo, saveRespaldo } from '../../helpers';

export default {

  name: 'Imagenes',

  components:{
    RegistrarEnvioImagenes
  },

  data() {
    return {
      visibleBody: false,
      dataRespaldo:[]
    };
  },


  async created() {
    this.loadData();
  },


  methods: {

    async loadData(){
      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;
      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if(this.idCita)
        this.dataRespaldo = loadRespaldo(this.idCita, 'imagenes');
      
      // console.log('dataRespaldo', this.dataRespaldo);
    },


    saveImagenesInState(imagenesList){
      if(this.identificadorAtencion)
        saveRespaldo(this.identificadorAtencion, 'imagenes', imagenesList);
    }
  },

  computed:{

    ...mapState({
      stDataCobertura: state => state.atencionCita?.dataCita?.cobSeleccionada.id,
    }),


    esCoberturaIess(){
      return this.stDataCobertura === '1'
    }
  }

  
}
</script>
